import React from 'react';

import { Button } from '@mesh.ai/rabbit';
import { useQueryClient } from '@tanstack/react-query';
import { Macros } from 'interfaces/Macros';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getApiBodyFromEditorStateAndMedia } from 'services/helpers/post';

import { useCompetencyDrawerState } from '../competencyDrawerSlice';
import { useGetLevelUpDetailsQuery, useUpdateCompetencyProgressMutation } from '../dataHooks';
import { useHasDataChanged } from '../helpers/useHasDataChanged';

export const CheckinButton = () => {
  const queryClient = useQueryClient();
  const { comment, progressScore, progressLabel, uploadedImage, uploadedGif } = useCompetencyDrawerState();
  const { data: levelUpCompetencyDetails } = useGetLevelUpDetailsQuery();

  const { mutate: updateProgress, isLoading } = useUpdateCompetencyProgressMutation();

  const hasDataChanged = useHasDataChanged();

  const progress = levelUpCompetencyDetails?.progressStages.find((stage) => stage.progress === progressLabel);

  const handleCheckIn = () => {
    const editorMetadata: { text: string; macros: Macros } = getApiBodyFromEditorStateAndMedia(
      comment,
      [...(uploadedImage ? [uploadedImage] : []), ...(uploadedGif ? [uploadedGif] : [])],
      false,
      null
    );
    updateProgress({
      progressId: progressScore !== levelUpCompetencyDetails?.progressPercentage ? progress.id : null,
      comment: editorMetadata.text.trim() || uploadedImage || uploadedGif ? editorMetadata : null,
    });
    // Invalidate the review all competency summary query to refetch the data
    queryClient.invalidateQueries([REACT_QUERY_KEYS.ReviewAllCompetencySummary]);
  };

  return (
    <Button
      size="small"
      disabled={!hasDataChanged || isLoading || !levelUpCompetencyDetails?.isDetailAccessible}
      onClick={handleCheckIn}
    >
      Check-in
    </Button>
  );
};
